/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { EmailRequestBuilderRequestsMetadata, type EmailRequestBuilder } from './email/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /auth/sign-up
 */
export interface SignUpRequestBuilder extends BaseRequestBuilder<SignUpRequestBuilder> {
    /**
     * The email property
     */
    get email(): EmailRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SignUpRequestBuilderUriTemplate = "{+baseurl}/auth/sign-up";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SignUpRequestBuilderNavigationMetadata: Record<Exclude<keyof SignUpRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    email: {
        requestsMetadata: EmailRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
